import { createApi } from '@reduxjs/toolkit/query/react'
import {
  Apis,
  ConfigOptions,
  ConfigResponse,
  GetAppContextResponse,
  GetUserContextResponse,
} from '../types/sdk'
import { setAppContext } from './root'

const zoomSdkBaseQuery = async ({
  method,
  params,
}: {
  method: Apis | 'config'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any
}) => {
  try {
    const result = await zoomSdk[method](params)
    return { data: result }
  } catch (err) {
    let error = {
      error: {
        name: 'unknownError',
        message: 'unexpected error from sdk',
      },
    }

    if (err instanceof Error) {
      error = {
        error: {
          name: err?.status || err?.name,
          message: err?.data || err.message,
        },
      }
    }

    return error
  }
}

export const configParams: ConfigOptions = {
  version: '0.16',
  timeout: 60000, // helps with the system browser collab being slower than 10s
  capabilities: [
    'expandApp',
    'closeApp',
    'getAppContext',
    'getUserContext',
    'leaveCollaborate',
    'onCollaborateChange',
    'onRunningContextChange',
    'openUrl',
    'sendAppToBackground',
    'zmSystemBrowserCollaboration',
    'zmOnCollaborateRequest',
    'zmConfirmCollaborate',
    'startCollaborate',
    'zmOnOpenLink',
    'getCollaborateContext',
    'joinCollaborate',
  ],
  popoutSize: {
    height: 283,
    width: 360,
  },
}

export const zoomSdkApi = createApi({
  reducerPath: 'zoomSdk',
  baseQuery: zoomSdkBaseQuery,
  endpoints: (builder) => ({
    config: builder.query<ConfigResponse, 'config'>({
      query: () => ({ method: 'config', params: configParams }),
    }),
    getAppContext: builder.query<GetAppContextResponse, 'getAppContext'>({
      query: () => ({ method: 'getAppContext' }),
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        // allows the appContext to be directly placed into the store
        // needed for queries to add appContext to headers
        const { data } = await queryFulfilled
        dispatch(setAppContext(data))
      },
    }),
    getUserContext: builder.query<GetUserContextResponse, 'getUserContext'>({
      query: () => ({ method: 'getUserContext' }),
    }),
  }),
})

export const { useConfigQuery, useGetAppContextQuery, useGetUserContextQuery } =
  zoomSdkApi
